<div class="alert my-1 shadow-sm bg-primary text-white py-1">
  {{ titulo }}
</div>
